import { emptyMapping, fieldKeys, type ColumnMapping, type FieldKey } from '../domain/catalog'

const aliases: Record<FieldKey, string[]> = {
  sku: ['sku', 'sifra', 'artikl', 'sifra artikla', 'item code', 'product code', 'code'],
  name: ['naziv', 'ime', 'naziv artikla', 'product name', 'name', 'description'],
  price: ['nabavna cena', 'cena', 'mpc', 'price', 'cost', 'purchase price', 'unit price'],
  stock: ['stanje', 'lager', 'kolicina', 'quantity', 'qty', 'stock'],
  category: ['kategorija', 'grupa', 'category', 'product category'],
  image: ['slika', 'slika url', 'image', 'image url', 'photo', 'picture'],
}

export function normalizeHeader(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[_\-]+/g, ' ')
    .replace(/[^a-z0-9 ]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

export function detectMapping(headers: string[]): ColumnMapping {
  const mapping = emptyMapping()
  const normalized = headers.map((header) => ({ header, normalized: normalizeHeader(header) }))

  for (const key of fieldKeys) {
    const exact = normalized.find((candidate) => aliases[key].includes(candidate.normalized))
    if (exact) {
      mapping[key] = exact.header
      continue
    }

    const partial = normalized.find((candidate) =>
      aliases[key].some((alias) => candidate.normalized.includes(alias) || alias.includes(candidate.normalized)),
    )
    if (partial) mapping[key] = partial.header
  }

  return mapping
}
